// extracted by mini-css-extract-plugin
export var messageSideLeft = "_l3-1";
export var messageSideRight = "_l3-2";
export var orderLookupBubbleContainer = "_l3-0";
export var submitButton = "_l3-3";